(function () {
  var listSelectDirective = "listSelect";

  angular
    .module("app")
    .directive(listSelectDirective, ["$timeout", "$document",
      function ($timeout, $document) {
        return {
          restrict: "A",
          link: function (scope, element, attrs) {
            // don't auto focus the list all the time.  when the list items are in a filtered list, if the user types into the filter, the filter loses focus because the list item would steal focus
            if (attrs.listSelectSkipAutoFocus !== "true") {
              if (scope.$last) {
                $timeout(function () {
                  element.parent().children().first().focus();
                }, 1);
              }
            }

            element.bind("focusout", function (event) {
              element.removeClass("selected").siblings().removeClass("selected");
            });

            element.bind("focus", function (event) {
              element.removeClass("selected").siblings().removeClass("selected");
              element.addClass("selected");
            });

            element.bind("keydown keypress", function (event) {
              if (event.which === 13) {
                scope.$apply(function () {
                  scope.$eval(attrs.listSelectOnEnter);
                });
                event.preventDefault();
              }

              if (event.which === 38) { //up arrow
                if (!element.is(element.parent().children().first())) {
                  element.prev().focus();
                } else if (attrs.listInputClass) {
                  //Focus the previous input this list belongs to.
                  var inputs = $document[0].getElementsByClassName(attrs.listInputClass);
                  for (var i = 0; i < inputs.length; i++) {
                    inputs[i].focus();
                  }
                }

                if (attrs.listSelect !== "") {
                  element.parent().children(".selected").click();
                }

                return false;
              }

              if (event.which === 40) { //down arrow
                if (!element.is(element.parent().children().last())) {
                  element.next().focus();
                }

                if (attrs.listSelect !== "") {
                  element.parent().children(".selected").click();
                }

                return false;
              }
            });
          }
        };
      }
    ]);
})();




// WEBPACK FOOTER //
// ./app/components/list.directive.js